import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilService } from '../util/util.service'; //app/shared/index barrel;
import { DialogModal } from './dialog-modal.model';
import { DialogResult } from './dialog-result.model';
import { DialogService } from './dialog.service';

@Component({
  selector: 'wl-dialog',
  templateUrl: 'dialog.component.html',
  styleUrls: ['dialog.component.css'],
    standalone: false
})
export class DialogComponent {
  public _dialogService: DialogService;
  public dialog: DialogModal;

  public showModal = false;
  public showWaitModal = false;
  public showErrorModal = false;

  public constructor(dialogService: DialogService) {
    this._dialogService = dialogService;
    this.dialog = new DialogModal();

    this._dialogService.dialogAdded.subscribe((dialog: DialogModal) => {
      this.dialog = dialog;
      if (dialog.isWaitIndicator == true) {
        if (dialog.show == false) {
          setTimeout(() => {
            this.showWaitModal = false;
          }, 500);
        } else {
          this.dialog = dialog;
          this.showWaitModal = true;
        }
      } else {
        if (dialog.show == false) {
          if (dialog.isErrorDialog == true) {
            setTimeout(() => {
              this.showErrorModal = false;
            }, 500);
          } else {
            setTimeout(() => {
              this.showModal = false;
            }, 500);
          }
        } else {
          this.dialog = dialog;
          if (dialog.isErrorDialog == true) {
            this.showErrorModal = true;
          } else {
            this.showModal = true;
          }
        }
      }
    });
  }

  public dialogYes(): void {
    this.dialog.show = false;
    this.dialog.dialogResult = DialogResult.Yes;
    this.showModal = false;
    if (this.dialog.yesFunction) {
      this.dialog.yesFunction();
    }
  }
  public dialogNo(): void {
    this.dialog.show = false;
    this.dialog.dialogResult = DialogResult.No;
    this.showModal = false;
    if (this.dialog.noFunction) {
      this.dialog.noFunction();
    }
  }
  public dialogCancel(): void {
    this.dialog.show = false;
    this.dialog.dialogResult = DialogResult.Cancel;
    this.showModal = false;
  }

  public dialogOk(): void {
    this.dialog.show = false;
    this.dialog.dialogResult = DialogResult.Ok;
    if (this.dialog.isErrorDialog == true) {
      this.showErrorModal = false;
    } else {
      this.showModal = false;
    }
  }
}
